
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
import { getAllOperList } from "@/api/api-basic";
@Component
export default class SelectOper extends Vue {
  @Prop({ default: "" }) private width!: number | string;
  @Prop({ default: "" }) private pkid!: number | string;
  @Watch("pkid")
  getVisible() {
    this.oprPkId = this.pkid + "";
  }
  private oprList: object[] = [];

  private oprPkId = "";
  async getStation(): Promise<void> {
    const ret = await getAllOperList({ oprId: this.pkid });
    if (ret.status === this.$config.apiStatus) {
      this.oprList = ret.data;
      this.$emit("success", this.oprList);
    }
  }

  public selectOperChange(val: string): void {
    val = !val || val == "0" ? "" : val;
    this.$emit("change", val);
  }

  mounted() {
    this.getStation();
  }
  // activated() {
  //   this.getStation();
  // }
}
